import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

const LS_KEY = "joypearl_consent_v1";

export const ConsentBanner = () => {
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(LS_KEY)) { setVisible(false); return; }
    setVisible(true);
  }, []);

  const decide = async (marketing, analytics) => {
    localStorage.setItem(LS_KEY, JSON.stringify({ terms: true, marketing, analytics, ts: Date.now() }));
    setVisible(false);
    if (user) {
      try { await api.post("/dpdp/consent", { terms: true, marketing, analytics }); }
      catch { /* ignore — saved locally already */ }
    }
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-16 md:bottom-4 left-2 right-2 md:left-auto md:right-4 z-50 max-w-md bg-white border border-brand-line shadow-xl p-5 jp-fade-up" data-testid="consent-banner">
      <h3 className="font-serif text-lg text-brand-ink mb-1">Your privacy at Joy Pearl</h3>
      <p className="text-xs text-brand-muted leading-relaxed">
        We use essential cookies to run vskstore.com and your account. With your consent we'd like to send order updates by marketing channels and measure basic site analytics. You can change this any time in your account.
      </p>
      <div className="mt-3 flex flex-wrap gap-2">
        <button onClick={() => decide(true, true)} className="jp-btn-primary px-3 py-2 text-xs" data-testid="consent-accept-all">Accept all</button>
        <button onClick={() => decide(false, false)} className="jp-btn-outline px-3 py-2 text-xs" data-testid="consent-essential">Essential only</button>
        <Link to="/legal/privacy" className="text-xs text-brand-muted hover:text-brand-primary self-center underline ml-auto">Learn more</Link>
      </div>
    </div>
  );
};
